import React, { useEffect, useMemo, useState } from "react";
import ConfigDB from "../Config/ThemeConfig";
import storage from "../utils/storage";
import CustomizerContext from "../_helper/Customizer";
import AnimationThemeContext from "../_helper/AnimationTheme";

const DEFAULT_LAYOUT_KEY = "Dubai";
const DEFAULT_LAYOUT_VALUE = "compact-wrapper";

// Tek tema/layout provider'ı. Cuba "ThemeCustomizer" demo paneli söküldüğünden
// (addLayout/addColor/addSidebar*/mixLayout/sidebarResponsive vb.) ölü API'ler
// kaldırıldı. Geriye kalan TEK sorumluluk: sidebar collapse durumu + layout/
// iconType okuması + router animasyonu. Tüketiciler yalnızca aşağıdaki değerleri
// kullanır: layout, sidebarIconType, toggleIcon, setToggleIcon, toggleSidebar,
// layoutURL, customizer.
const ThemeProvider = ({ children }) => {
  const customizer = ConfigDB.data;

  const [layout, setLayout] = useState(DEFAULT_LAYOUT_VALUE);
  const [sidebarIconType, setSidebarIconType] = useState(
    customizer.settings.sidebar.iconType
  );
  // Sidebar daralt/genişlet durumu kullanıcı tercihidir → localStorage'da
  // kalıcı (sayfa geçişinde/yenilemede sıfırlanmasın). Default: daraltılmış.
  const [toggleIcon, setToggleIconState] = useState(() => {
    try {
      const v = localStorage.getItem("pms_sidebar_collapsed");
      return v === null ? true : v === "true";
    } catch {
      return true;
    }
  });
  const setToggleIcon = (val) => {
    setToggleIconState((prev) => {
      const next = typeof val === "function" ? val(prev) : val;
      try {
        localStorage.setItem("pms_sidebar_collapsed", String(next));
      } catch {
        /* storage yoksa sessizce geç */
      }
      return next;
    });
  };
  const toggleSidebar = (toggle) => setToggleIcon(toggle);

  const [animation, setAnimation] = useState(
    storage.theme.getAnimation() || customizer.router_animation
  );

  const layoutURL = storage.theme.getLayout() || DEFAULT_LAYOUT_KEY;

  useEffect(() => {
    setSidebarIconType(
      storage.theme.getSidebarIconType() || customizer.settings.sidebar.iconType
    );
    const storedLayout = storage.theme.getSidebarLayout();
    if (storedLayout) {
      customizer.settings.sidebar.type = storedLayout;
      setLayout(storedLayout);
    }
    customizer.settings.sidebar_setting = "default-sidebar";
  }, []);

  const routerAnimation = (anim) => {
    customizer.router_animation = anim;
    storage.theme.setAnimation(anim);
    setAnimation(anim);
  };

  const customizerValue = useMemo(
    () => ({
      layout,
      sidebarIconType,
      toggleIcon,
      setToggleIcon,
      toggleSidebar,
      layoutURL,
      customizer,
    }),
    [layout, sidebarIconType, toggleIcon, layoutURL]
  );

  const animationValue = useMemo(
    () => ({ animation, routerAnimation }),
    [animation]
  );

  return (
    <CustomizerContext.Provider value={customizerValue}>
      <AnimationThemeContext.Provider value={animationValue}>
        {children}
      </AnimationThemeContext.Provider>
    </CustomizerContext.Provider>
  );
};

export default ThemeProvider;
